export const UserTagIcon = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 13.0732H11.4933C10.96 13.0732 10.4533 13.2798 10.08 13.6532L8.93998 14.7798C8.41998 15.2932 7.57334 15.2932 7.05334 14.7798L5.91333 13.6532C5.54 13.2798 5.02667 13.0732 4.5 13.0732H4C2.89333 13.0732 2 12.1865 2 11.0932V3.81982C2 2.72649 2.89333 1.83984 4 1.83984H12C13.1067 1.83984 14 2.72649 14 3.81982V11.0932C14 12.1798 13.1067 13.0732 12 13.0732Z"
      stroke="#010D1D"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 7.16622C8.85788 7.16622 9.55334 6.47076 9.55334 5.61287C9.55334 4.75499 8.85788 4.05957 8 4.05957C7.14212 4.05957 6.44666 4.75499 6.44666 5.61287C6.44666 6.47076 7.14212 7.16622 8 7.16622Z"
      stroke="#010D1D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6667 10.9399C10.6667 9.7399 9.47337 8.7666 8.00004 8.7666C6.52671 8.7666 5.33337 9.7399 5.33337 10.9399"
      stroke="#010D1D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
